export const InternalTenantConnection = 'customink-internal-tenant';
